export default {
  hero: {
    title: "哔咔动漫 · 免费漫画天堂",
    subtitle: "日漫韩漫国漫海量资源 · 全免费下拉式在线阅读 · 一次性看完所有热门连载与完结作品",
    cta: "开始阅读",
    secondaryCta: "热门推荐",
  },
  categories: {
    title: "漫画分类",
    subtitle: "海量资源覆盖全品类，总有一款适合你",
  },
  hotRecommend: {
    title: "热门推荐",
    subtitle: "千万读者口碑之选，好评如潮的必看漫画",
  },
  latestUpdate: {
    title: "最新更新",
    subtitle: "每日更新，追更不停，精彩内容第一时间送达",
  },
  rankings: {
    title: "人气排行",
    subtitle: "实时排名，看看大家都在看什么",
  },
  features: {
    title: "为什么选择哔咔动漫",
    subtitle: "我们为漫画爱好者打造极致的免费阅读体验",
    items: [
      {
        icon: "ri-vip-crown-line",
        title: "全免费",
        desc: "日漫韩漫国漫全覆盖，零付费零门槛，畅享全部漫画资源",
      },
      {
        icon: "ri-smartphone-line",
        title: "下拉阅读",
        desc: "流畅的下拉式阅读体验，无需翻页，沉浸式追漫停不下来",
      },
      {
        icon: "ri-flashlight-line",
        title: "极速更新",
        desc: "连载漫画同步更新，第一时间推送最新章节，追更无需等待",
      },
      {
        icon: "ri-global-line",
        title: "多端适配",
        desc: "手机、平板、电脑全平台完美适配，随时随地畅快阅读",
      },
    ],
  },
  cta: {
    title: "立即开始你的免费漫画之旅",
    subtitle: "加入百万漫画爱好者，日漫韩漫国漫全免费，无限下拉阅读畅享不停",
    button: "免费开始阅读",
  },
};